import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'

export const CreateDailyExpense = createAsyncThunk(
  'daily-expense-store',
  async (data: {}, thunkAPI) => {
    try {
      return await axios.post(`${api}school-daily-expense/store-daily-expense`, data)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditDailyExpense = createAsyncThunk(
  'daily-expense-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-daily-expense/edit-daily-expense/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DeleteDailyExpense = createAsyncThunk(
  'daily-expense-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-daily-expense/delete-daily-expense/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetDailyExpenseReport = createAsyncThunk(
  'get-daily-expense-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-daily-expense/get-daily-expense-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DailyExpensePrintReport = createAsyncThunk(
  'daily-expense-print-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-daily-expense/daily-expense-print-report`, {
        params,
      })

      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const DailyExpenseExcelReport = createAsyncThunk(
  'daily-expense-excel-report',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-daily-expense/daily-expense-excel-report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

type DailyExpenseState = {
  errors: any
}

const initialState: DailyExpenseState = {
  errors: '',
}

export const dailyExpenseSlice = createSlice({
  name: 'school-daily-expense',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
})

export const {reset} = dailyExpenseSlice.actions
export default dailyExpenseSlice.reducer
